import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  FETCH_INVENTORY_REPORTS_SUCCESS,
  FETCH_INVENTORY_REPORTS_FAIL,
  DELETE_INVENTORY_REPORT_SUCCESS,
  CREATE_INVENTORY_REPORT_SUCCESS,
  CREATE_INVENTORY_REPORT_FAILURE,
  UPDATE_INVENTORY_REPORT,
  FETCH_ARCHIVED_INVENTORY_REPORTS_SUCCESS,
  FETCH_SHOPIFY_LOCATIONS_SUCCESS,
  FETCH_SHOPIFY_LOCATIONS_FAILURE
} from '../constants';

export function fetchInventoryReports(page = 1, mode = '') {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    const apiUrl = `${url}/inventory_reports.json?page=${page}&mode=${encodeURIComponent(mode)}`.replace(/\/+$/, '');

    axios({
      method: 'get',
      url: apiUrl,
      headers: { Authorization: `Bearer ${access_token}`}
    })
      .then(async response => {
        const { store_id, inventory_reports, pagy, general_setting } = response.data;
        await AsyncStorage.setItem('inventory_store_id', store_id.toString());
        if (general_setting) {
          await AsyncStorage.setItem('default_inventory_location', JSON.stringify(general_setting.default_inventory_location));
          await AsyncStorage.setItem('default_inventory_quantity_type', JSON.stringify(general_setting.default_inventory_quantity_type));
        }
        dispatch({
          type: FETCH_INVENTORY_REPORTS_SUCCESS,
          payload: { inventory_reports, pagy }
        });
        return response.data.pagy;
      })
      .catch(error => {
        dispatch({
          type: FETCH_INVENTORY_REPORTS_FAIL,
          payload: error?.response?.status
        });
        throw error;
      });
  };
}

export function showInventoryReport(id) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    try {
      const response = await axios({
        method: 'get',
        url: `${url}/inventory_reports/${id}`,
        headers: { Authorization: `Bearer ${access_token}` }
      });

      dispatch({
        type: FETCH_INVENTORY_REPORTS_SUCCESS,
        payload: {
          inventory_reports: [response.data.inventory_report],
          inventory_report_items: response.data.inventory_report_items
        }
      });

      return response.data;
    } catch (error) {
      dispatch({
        type: FETCH_INVENTORY_REPORTS_FAIL,
        payload: error?.response?.status
      });
      throw error;
    }
  };
}

export function createInventoryReport({ name, store_id, report_type }) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    try {
      const response = await axios({
        method: 'post',
        url: `${url}/inventory_reports.json`,
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        data: {
          inventory_report: {
            name,
            store_id,
            report_type
          },
        },
      });
      dispatch({
        type: CREATE_INVENTORY_REPORT_SUCCESS,
        payload: response.data,
      });
      
      return response.data;
    } catch (error) {
      dispatch({
        type: CREATE_INVENTORY_REPORT_FAILURE,
        payload: error?.response?.status,
      });
      throw error;
    }
  };
}

export function deleteInventoryReport(id) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    axios({
      method: 'delete',
      url: `${url}/inventory_reports/${id}`,
      headers: { Authorization: `Bearer ${access_token}` }
    })
      .then(response => {
        dispatch({
          type: DELETE_INVENTORY_REPORT_SUCCESS,
          payload: id
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_INVENTORY_REPORTS_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function exportInventoryReport(id, mode) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    try {
      const response = await axios({
        method: 'get',
        url: `${url}/inventory_reports/${id}/export_inventory_report?mode=${encodeURIComponent(mode)}`,
        headers: { Authorization: `Bearer ${access_token}` },
      });

      return response.data.message;
    } catch (error) {

      dispatch({
        type: FETCH_INVENTORY_REPORTS_FAIL,
        payload: error?.response?.status,
      });

      throw error;
    }
  };
}

export function restoreInventoryReport(id) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    try {
      const response = await axios({
        method: 'get',
        url: `${url}/inventory_reports/${id}/restore_inventory_report`,
        headers: { Authorization: `Bearer ${access_token}` },
      });

      return response.data.message;
    } catch (error) {
      dispatch({
        type: FETCH_INVENTORY_REPORTS_FAIL,
        payload: error?.response?.status,
      });
      throw error;
    }
  };
}

export function fetchArchivedInventoryReports(page = 1, mode = '') {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    axios({
      method: 'get',
      url: `${url}/inventory_reports/archived_inventory_reports.json?page=${page}&mode=${encodeURIComponent(mode)}`,
      headers: { Authorization: `Bearer ${access_token}` }
    })
      .then(response => {
        const { inventory_reports, pagy } = response.data;
        dispatch({
          type: FETCH_ARCHIVED_INVENTORY_REPORTS_SUCCESS,
          payload: { inventory_reports, pagy }
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_INVENTORY_REPORTS_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function updateReportToArchived(id) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    return axios({
      method: 'patch',
      url: `${url}/inventory_reports/${id}/mark_as_archived.json`,
      headers: { Authorization: `Bearer ${access_token}` }
    })
      .then(response => {
        dispatch({
          type: UPDATE_INVENTORY_REPORT,
          payload: response.data
        });
        return response.data.message;
      })
      .catch(error => {
        dispatch({
          type: FETCH_INVENTORY_REPORTS_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function createInventoryReportItems({ id, name, quantity_to_receive, final_quantity_on_hand, current_quantity_on_hand, discrepancy, mode, sku, product_id, report_status }) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const inventory_report_item = {
      inventory_report_id: id,
      product_name: name,
      quantity_to_receive,
      current_quantity_on_hand,
      sku: sku,
      product_id
    };

    if (mode === 'recount') {
      inventory_report_item.discrepancy = discrepancy;
    } else if (mode === 'receive') {
      inventory_report_item.final_quantity_on_hand = final_quantity_on_hand;
    }

    if (report_status) {
      inventory_report_item.report_status = report_status;
    }

    axios({
      method: 'post',
      url: `${url}/inventory_reports/create_inventory_report_item.json`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      data: { inventory_report_item },
    })
      .then(response => {
        dispatch({
          type: CREATE_INVENTORY_REPORT_SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({
          type: CREATE_INVENTORY_REPORT_FAILURE,
          payload: error?.response?.status,
        });
      });
  };
}

export function fetchShopifyLocations(storeIds, reportId = null) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    let params = {};
    if (reportId) {
      params.report_id = reportId;
    } else if (storeIds && storeIds.length > 0) {
      params.store_ids = storeIds.join(',');
    } else {
      dispatch({
        type: FETCH_SHOPIFY_LOCATIONS_FAILURE,
        payload: 'No store IDs or report ID provided.'
      });
      return;
    }

    axios({
      method: 'get',
      url: `${url}/inventory_reports/get_shopify_locations.json`,
      params: params,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
      .then(response => {
        dispatch({
          type: FETCH_SHOPIFY_LOCATIONS_SUCCESS,
          payload: response.data.locations,
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_SHOPIFY_LOCATIONS_FAILURE,
          payload: error?.response?.status || 'Failed to fetch Shopify locations.',
        });
      });
  };
}

export function fetchShopifyProductInventory(reportId, locationId, locationName, productIds, selectedOption) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    try {
      const response = await axios.get(`${url}/inventory_reports/get_shopify_product_inventory.json`, {
        params: { 
          report_id: reportId,
          location_id: locationId || '',
          product_ids: productIds.join(','),
          selected_option: selectedOption,
          location_name: locationName
        },
        headers: { 
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}

export function fetchShopifyInventoryWithDefaultLocations(reportId, locationId, locationName, productIds, selectedOption) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    try {
      const response = await axios.get(`${url}/inventory_reports/get_shopify_inventory_with_default_locations.json`, {
        params: {
          report_id: reportId,
          location_id: locationId || '',
          product_ids: productIds,
          selected_option: selectedOption,
          location_name: locationName
        },
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}

export function checkPushPermissions(reportId = null) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    try {
      const params = {};
      if (reportId) {
        params.report_id = reportId;
      }

      const response = await axios({
        method: 'get',
        url: `${url}/inventory_reports/check_push_permissions.json`,
        params: params,
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}

export function pushInventoryToShopify(reportId, locationId, locationName, productIds, selectedOption, editedQuantities = {}, productUpdates = []) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    try {
      const response = await axios({
        method: 'post',
        url: `${url}/inventory_reports/push_inventory_to_shopify.json`,
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        data: {
          report_id: reportId,
          location_id: locationId,
          location_name: locationName,
          product_ids: productIds.join(','),
          selected_option: selectedOption,
          edited_quantities: editedQuantities,
          product_updates: productUpdates
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
